import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="page"
export default class extends Controller {
    openDrawer(e) {
        e.preventDefault(); // Prevent default link navigation
        var event = new Event("drawer.open");
        event.url = $(e.target).closest('[data-drawer-url]').attr('data-drawer-url');
        document.dispatchEvent(event);
    }

    // No-op handler; pair with `:stop` action option (e.g.
    // `data-action="click->page#stopProp:stop"`) to prevent click events from
    // bubbling to an ancestor with its own page#openDrawer / similar action.
    stopProp(e) {
        e.stopPropagation();
    }

    closeDrawer(e) {
        if (e && e.preventDefault) {
            e.preventDefault();
        }

        var event = new Event("drawer.close");
        document.dispatchEvent(event);
    }
}
